export enum DATA_QA_ATTRIBUTES {
	CONTENT_FOOTER_SELECT = 'sidebar-content-footer-select',
	CONTENT_FOOTER_TEXT_AREA = 'sidebar-content-footer-text-area',
}
